<template>
  <div class="hy-index">
    <userinfo></userinfo>
    <!--列表-->
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title active" style="margin-bottom:10px;">
          开发票
          <!--  <van-dropdown-menu>
<van-dropdown-item v-model="value1" :options="option1" @change="changeType" />
  </van-dropdown-menu>-->
          <router-link class="piao-link" to="/invoiceList">
            发票管理
          </router-link>
        </h5>
        <!-- <div class="piao_set">
         <van-checkbox v-model="allChecked" shape="square" @change="changeQuan">全选</van-checkbox>
          <span class="goKai" @click="goKaipiao">去开票</span>
  </div>-->
        <van-list v-model="loading" :finished="finished" :finished-text="moreText" @load="onLoad">
          <van-cell v-for="(item,index) in tuiList" :key="item.id">
            <div class="order_nobox">
              <div class="order_statusbox">
             <!--   <span class="goKai" @click="goadd(index)">去开票</span>-->
                <!-- <van-checkbox v-model="item.checked" shape="square"></van-checkbox>-->
                <span class="o_status">{{item.order_info.order_no}}</span>
              </div>
            </div>

            <div class="imgbox">
              <router-link class="nav-link" :to="'/orderDetails/'+item.order_info.order_no">
                <img :src="item.conference.conference.cover_url" alt />
                <span class="text_icon" v-if="item.conference.conference.status_str == '待发布'">{{item.conference.conference.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="item.conference.conference.status_str == '已发布' || item.conference.conference.status_str == '报名中'">{{item.conference.conference.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.conference.conference.status_str == '会议中'">{{item.conference.conference.status_str }}</span>
                <span class="text_icon icon_blue" v-else-if="item.conference.conference.status_str == '已结束'">{{item.conference.conference.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="item.conference.conference.status_str == '未到报名时间'">{{item.conference.conference.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.conference.conference.status_str == '报名截止'">{{item.conference.conference.status_str }}</span>
                <span class="text_icon icon_black" v-else>{{item.conference.conference.status_str}}</span>
                <!-- <span class="text_icon icon_black">已结束</span> -->
                <!-- <span class="text_icon icon_blue">活动中</span> -->
              </router-link>
            </div>
            <div class="textbox">
              <div class="title">
                <router-link class="nav-link" :to="'/orderDetails/'+item.order_info.order_no">
                  <h5>{{item.conference.conference.name}}</h5>
                  <span class="type" v-if="item.conference.conference.type == 1">会议</span>
                  <span class="type" v-else-if="item.conference.conference.type == 2">沙龙</span>
                  <span class="type" v-else-if="item.conference.conference.type == 3">活动</span>
                  <!-- <span class="type">活动</span> -->
                </router-link>
              </div>
              <div class="textinfo">
                <span class="iconfont">&#xe67f;</span>
                {{item.conference.conference.start_time,'Y-M-D'|formatDates}}~{{item.conference.conference.end_time,'Y-M-D'|formatDates}}
              </div>
              <div class="textinfo">
                <span class="iconfont">&#xe64d;</span>
                {{item.conference.conference.region}}&nbsp;{{item.conference.conference.specific_address}}
              </div>
              <div class="order_nobox">
                <div class="order_statusbox border">
                  <span class="o_time">{{item.order_info.start_time,'Y-M-D h:m:s'|formatDates}}</span>
                  <span class="o_status">合计：￥{{item.order_info.amount}}</span>
                </div>
                <div class="btnBox">
                  <a class="nav-link blue" v-if="item.conference.conference.jump_page == 1" :href="'/index/Conference/template?id='+item.conference.conference.id"><span class="text">会议首页</span></a>
                  <router-link class="nav-link blue" v-else-if="item.conference.conference.jump_page == 2" :to="'/info/'+item.conference.conference.id"><span class="text">会议首页</span></router-link>
                  <router-link class="nav-link blue" v-else-if="item.conference.conference.jump_page == 3" :to="'/shares/1?id='+item.conference.conference.id"><span class="text">会议首页</span></router-link>

                  <router-link class="nav-link blue" :to="'/orderDetails/'+item.order_info.order_no"><span class="text">查看订单</span></router-link>
                  <a class="nav-link kaipiao" @click="goadd(index)"><span class="text">去开票</span></a>
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
    <!--<div class="hy-fixed-userBtn">
      <router-link class="iconfont fixed-link" to="/">&#xe60e;</router-link>
    </div>-->
  </div>
</template>
<script>
  import {
    formatDates
  } from "../../assets/js/date"
  import userinfo from '@/components/common/userinfo'
  export default {
    components: {
      userinfo
    },
    data() {
      return {
        allChecked: false,
        moreText: '没有更多了',
        searchValue: "",
        tuiList: [],
        loading: false,
        finished: false,
        page: 0,
        pagesize: 10,
      };
    },
    created() {
      var _this = this;
      _this.$WXConfig.wxShowMenu({
        ifshare: true,
        that: _this,
        data: ''
      });

    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      //banner跳转方法
      goPath(path) {
        if (path == "") {
          return false;
        }
        // this.$router.push(path);
        window.location.href = path;
      },
      /* 初始化数据列表 */
      onLoad(page, pagesize) {
        var _this = this;
        let url = "/ac1/conference/myOrderInvoiced";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize,
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            // 加载状态结束
            _this.loading = false;
            if (res.posts.length < _this.pagesize) {
              _this.finished = true;
              if (_this.page == 1 && res.posts.length == 0) {
                _this.moreText = '暂无内容';
              }
            }
            res.posts.forEach(v => {
              v.checked = false;
              _this.tuiList.push(v);
            });
            _this.page = _this.page + 1;
          } else {
            _this.$toast(res.msg);
          }
        }, function(res) {
          console.log(res.msg);
        });
      },
      changeQuan() {
        var _this = this;
        for (var i = 0; i < _this.tuiList.length; i++) {
          _this.tuiList[i].checked = JSON.parse(JSON.stringify(_this.allChecked));
        }
      },
      goKaipiao() {
        var _this = this;
        var order_no = '',
          allAmount = 0,
          dep_code = '';
        for (var i = 0; i < _this.tuiList.length; i++) {
          if (_this.tuiList[i].checked) {
            order_no += ',' + _this.tuiList[i].order_info.order_no;
            allAmount = parseFloat(allAmount) + parseFloat(_this.tuiList[i].order_info.amount);
            dep_code += ',' + _this.tuiList[i].order_info.dep_code;
          }
        }
        localStorage.setItem('invoiceMenu', JSON.stringify({
          order_no: order_no.substr(1),
          allAmount: allAmount,
          dep_code: dep_code.substr(1)
        }));
        if (order_no.length > 0) {
          _this.$router.push('/addInvoice');
        } else {
          _this.$toast('请选择开票商品！');
        }
      },
      goadd(i) {
        var _this = this;
        var order_no = '',
          allAmount = 0,
          dep_code = '',
          code = '';
        order_no += ',' + _this.tuiList[i].order_info.order_no;
        allAmount = parseFloat(allAmount) + parseFloat(_this.tuiList[i].order_info.amount);
        dep_code += ',' + _this.tuiList[i].order_info.dep_code;
        code = _this.tuiList[i].conference.conference.code;
        localStorage.setItem('invoiceMenu', JSON.stringify({
          order_no: order_no.substr(1),
          allAmount: allAmount,
          dep_code: dep_code.substr(1),
          code: code
        }));
        _this.$router.push('/addInvoice');
      }
    }
  };
</script>
<style lang="less">
  .order_nobox {
    width: 100%;
    padding: 10px 0px;

    .order_statusbox {
      width: 100%;
      overflow: hidden;
      padding: 0 15px;

      .van-checkbox {
        float: left;
        max-width: 20%;
      }

      span {
        color: #999;
        font-size: 28px;

        &.o_time {
          float: left;
        }

        &.o_status {
          float: right;
          color: #fe6333;
        }
      }

      &.border {
        border-top: 2px solid #ebebeb;
        border-bottom: 2px solid #ebebeb;
        padding: 15px;
      }

      .goKai {
        font-size: 24px;
        color: #FFF;
        height: 40px;
        line-height: 40px;
        background: #fe6333;
        padding: 5px 20px;
        border-radius: 5px;
      }
    }

    .btnBox {
      width: 100%;
      display: flex;
      padding-top: 20px;

      a {
        display: block;
        flex: 1;
        overflow: hidden;
        text-align: center;

        &.blue {
          color: #1994fb;
        }

        &.yellow {
          color: #fe6333;
        }

        &.hui {
          color: #999;
        }
        &.kaipiao{
          background-color: #fe6333;
          color: #FFF;
          border-radius: 5px;
        }
      }
    }
  }
</style>
